export const DEFAULT_NUM_OF_GROUPS = 2;
